<template>
    <span v-if="cronExpression">{{ nextIteration }}</span>
    <span v-else>/</span>
</template>

<script>
    import { getNextIteration } from '../../services/cron.service';
    import { dateToHuman } from '../../services/date.service';

    export default {
        name: 'NextGatewayFileDownloadCronTaskInfos',
        props: {
            cronExpression: null,
        },
        data() {
            return {
                interval: null,
                nextIteration: null,
            }
        },
        methods: {
            setNextIteration() {
                if (!this.cronExpression) {
                    return '/';
                }

                if (this.cronExpression === 'NEVER') {
                    this.nextIteration = this.$t('gateway.cronConfig.never');
                    return;
                }

                this.nextIteration = dateToHuman(getNextIteration(this.cronExpression));
            },
        },
        async created() {
            if (this.cronExpression) {
                this.setNextIteration();
                this.interval = setInterval(() => {
                    this.setNextIteration();
                }, 1000);
                return;
            }
        },
        beforeDestroy() {
            if (this.interval) {
                clearInterval(this.interval);
            }
        },
    }
</script>
